/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFigmaIcon20Light = forwardRef('LogoFigmaIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.341 7.5A2.997 2.997 0 0 0 5 10c0 1.043.533 1.963 1.341 2.5A3 3 0 1 0 11 15v-2.764A3 3 0 1 0 14.659 7.5 3 3 0 0 0 13 2H8a3 3 0 0 0-1.659 5.5ZM11 3v4h2a2 2 0 1 0 0-4h-2Zm-1 5H8a2 2 0 1 0 0 4h2V8ZM8 7h2V3H8a2 2 0 1 0 0 4Zm0 6h2v2a2 2 0 1 1-2-2Zm5-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" })));
});
